module.exports = __webpack_public_path__ + "static/13-1eecefe03e09ac85a1e1c624b8952702.jpeg";